<template>
<b-modal id="memberDocModal" modal-class="client-details-modal" centered size="lg" hide-footer no-close-on-backdrop hide-header-close @shown="getData">
    <template #modal-header>
        <div class="view-clients-header">
            <b-button variant="close-btn" class="btn-container" @click="closeModal">
                <i class="fas fa-times"></i>
            </b-button>
        </div>
    </template>
    <b-container fluid ref="memberDocContainer">
        <div class="view-clients-modal-content">
            <h6 v-if="user">
                {{ user.name }} -
                {{ member && member.policy_id ? member.policy_id : "" }}
            </h6>
            <p class="email-address">{{ user.email }}</p>
            <ul class="client-docs">
                <li v-if="loading">
                    <no-content text="Loading..." />
                </li>
                <li v-if="(!filteredFiles || filteredFiles.length === 0) && !loading">
                    <no-content text="No files found." />
                </li>
                <li v-for="(file, index) in filteredFiles" :key="index">
                    <div class="d-inline me-2">
                        <input type="checkbox" id="checkbox-1" class="m-2" name="checkbox-1" v-model="form.data" :value="file">
                    </div>
                    <!-- <b-form-checkbox
                id="checkbox-1"
                name="checkbox-1"
                v-model="form.data"
                :value="file"
              /> -->
                    <a :href="file.url" target="_blank">{{ file.filename }}</a>
                </li>
            </ul>
            <!-- <p class="new-rates" v-if="checkPlan()">
            New Rate as of January 1, 2025 -
            <router-link
            target="_blank"
              style="display:block;margin-bottom:4%"
              class="route-link"
              :to="'/document-view-details/' + base64Encode(member)"
              >Click here to view.</router-link
            >
          </p> -->
            <button type="button" class="univ-btn" :class="{ disabled: isDisabled }" @click="sendCardEmail" :disabled="isDisabled">
                {{ isSending ? " Sending Card" : " Send Card" }}
            </button>
        </div>
    </b-container>
</b-modal>
</template>

<script>
import Api from "@/resource/ApiV2";
import isEnrollPrimeGroupUtil from "@/utils/isEnrollPrimeGroupUtil";

export default {
    name: "MemberDocModal",
    data: () => ({
        targetPids: [],
        files: [],
        user: "",
        isSending: false,
        form: {
            policy_id: "",
            data: [],
        },
        isDisabled: true,
        emailContent: {
            email_message_configuration_name: "MEMBER_CARD_CONFIGURATION",
            toAddress: [], //member email
            ccAddress: [], //agent email
            bccAddress: [],
            subject: "Important Member Benefit Information",
            attachedFiles: [],
            generalTemplateData: [],
            contentData: {
                member: "", //member name
                cards: ""
            },
        },
        loading: false
    }),
    props: {
        member: {
            required: true,
        },
    },
    methods: {
        closeModal() {
            this.files = [];
            this.user = "";
            this.form = {
                policy_id: "",
                data: [],
            };
            this.$emit("onCloseModal");
            this.$bvModal.hide("memberDocModal");
        },
        sendCardEmail() {
            const url = `send-card-email`;
            this.isDisabled = true;
            let loader = this.$loading.show({
                container: this.$refs.memberDocContainer,
            });
            Api.post(url, this.form)
                .then((res) => {
                    this.$notify(res.data.message);
                    this.closeModal();
                })
                .catch((err) => {
                    this.$notify(err.response.data.message, "error");
                })
                .finally(() => {
                    this.isSending = false;
                    loader.hide();
                });
        },
        getData() {
            const url = `get-client-card-docs/${this.member.policy_id}`;
            let loader = this.$loading.show({
                container: this.$refs.memberDocContainer,
            });
            this.loading = true;
            Api.get(url)
                .then((res) => {
                    let data = res.data.data;
                    this.files = data.files;
                    this.user = data.user_details;
                    this.form.policy_id = this.member ? this.member.policy_id : "";
                })
                .catch((err) => {
                    this.$notify(err.response.data.message, "error");
                })
                .finally(() => {
                    loader.hide();
                    this.loading = false;
                });
        },
        base64Encode(member) {
            let user_id = member?.user_id;
            return btoa(user_id);
        },
        //   fetchTargetPids() {
        //     const url = `v2/get-renewal-pids`;
        //     Api.get(url)
        //         .then((res) => {
        //             this.targetPids = res.data.targetPids.map(Number); // Convert PIDs to numbers
        //         })
        //         .catch((err) => {
        //             this.$notify(err.response?.data?.message || "Failed to fetch target PIDs", "error"); // Handle errors
        //         })
        //   },
        //   checkPlan() {
        //     let status = false
        //     this.member?.plan_details?.forEach((plan) => {
        //         if (plan.plan_status === "ACTIVE" && this.targetPids.includes(plan.plan_id)) {
        //             status = true;
        //         }
        //     });
        //     return status;
        //   },
        getContentData() {
            let postData = {
                ...this.emailContent
            };
            this.form.data.forEach((file) => {
                postData.contentData.cards += `<a href="${file.url}" target="_blank" style="margin-top: 10px; margin-left: 5px;">${file.filename}</a>`;
                postData.contentData.cards += '<br>';
            })
            postData.toAddress = [this.member.user_email];
            postData.contentData.member = this.member.first_name + ' ' + this.member.last_name;
            return postData
        },
    },
    mounted() {
        // this.fetchTargetPids(); // Fetch PIDs when the component is loaded
    },
    computed: {
        filteredFiles() {
            return this.isEnrollPrime ? this.files.filter(file => file.filename !== 'Change/Termination Form') : this.files;
        },
        isEnrollPrime() {
            return isEnrollPrimeGroupUtil.isEnrollPrimeGroup();
        }
    },
    watch: {
        form: {
            handler: function (value) {
                if (value.policy_id && value.data.length > 0) {
                    this.isDisabled = false;
                } else {
                    this.isDisabled = true;
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.client-details-modal .modal-content {
    border: 0px;
    border-radius: 10px;
}

.client-details-modal .modal-content .modal-body {
    border: 0px;
    border-radius: 10px;
    max-height: 540px;
    overflow-y: auto;
}

.client-details-modal .modal-header {
    justify-content: center;
    border: 0;
    padding: 15px 0;
    position: relative;
}

.view-clients-header h4 {
    font-size: 20px;
    color: #2C3F58;
    font-weight: 600;
    margin: 0;
    margin-bottom: 20px;
}

.client-details-modal h6 {
    font-weight: bold;
    color: #2C3F58;
    margin-bottom: 20px;
}

.client-details-modal h6 a {
    color: #2C3F58;
}

.client-details-modal h6 a:hover {
    color: #4db7e9;
}

.client-details-modal ul {
    margin: 0;
    padding: 0;
    margin-bottom: 25px;
}

.client-details-modal ul li {
    list-style: none;
    font-size: 14px;
    opacity: 0.9;
}

.client-details-modal .client-docs {
    list-style: none;
    margin: 0;
    padding: 0;
    padding-bottom: 10px;
}

.client-details-modal .client-docs li {
    list-style: none;
    margin-bottom: 18px;
    border-bottom: 1px solid #efefef;
    padding-bottom: 13px;
}

.client-details-modal .client-docs li .custom-checkbox {
    display: inline-block;
    margin-right: 10px;
}

.client-details-modal .client-docs li .custom-checkbox input {
    cursor: pointer;
}

.view-clients-modal-content a {
    color: #4db7e9;
}

.view-clients-modal-content .email-address {
    margin-bottom: 20px;
    padding-bottom: 13px;
    opacity: 0.7;
}

.view-clients-modal-content .new-rates {
    font-size: 15px;
}

.view-clients-modal-content table {
    margin-top: 15px;
    width: 100%;
    margin-bottom: 25px;
}

.view-clients-modal-content table tr td:first-child {
    width: 30%;
}

.view-clients-modal-content table tr td {
    border: 1px solid #efefef;
    padding: 5px 10px;
    font-size: 14px;
    opacity: 0.9;
}

.view-clients-modal-content textarea {
    width: 100%;
    max-height: 120px;
    border: 1px solid #efefef;
    border-radius: 6px;
    background: #fff;
    margin-top: 10px;
}

.view-clients-header .btn-container {
    position: absolute;
    top: -14px !important;
    right: -15px;
    background: #fff;
    color: #000;
    border: 0;
    box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
    border-radius: 60px;
    font-size: 18px;
    width: 45px;
    height: 45px;
    align-items: center;
    justify-content: center;
    display: flex;
    z-index: 9;
}

.univ-btn {
    background: linear-gradient(#0cf, #1597b8 49%, #0567bc);
    border-radius: 6px;
    color: #fff;
    outline: none;
    border: 0;
    width: 100%;
    text-align: center;
    padding: 10px 0;
    margin-top: 10px;
    transition: all ease 0.6s;
}

.disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>
